import CloudImage from './CloudImage.component'
import { Transformation } from 'cloudinary-react'

export { Transformation, CloudImage }

export default CloudImage
